import { render, staticRenderFns } from "./car-fixed.vue?vue&type=template&id=035c7f76"
import script from "./car-fixed.vue?vue&type=script&lang=js"
export * from "./car-fixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonFavorite: require('/var/www/components/button/button-favorite.vue').default})
